import { Image } from '@/components/ui/image';
import ProductLoaderGif from '@/assets/placeholders/product-loader.gif';

interface ProductLoaderProps {
  width?: number;
}

const ProductLoader = ({ width = 200 }: ProductLoaderProps) => {
  return (
    <Image
      src={ProductLoaderGif}
      alt="logo da qualidoc animada"
      width={width}
      unoptimized={true}
    />
  );
};

export default ProductLoader;
